import React, {Component} from 'react'
import {Entity} from 'aframe-react'

import ToggleImage from "../assets/icons/switch-img.png"
import ToggleText from "../assets/icons/switch-txt.png"
import PanelBackground from "../assets/icons/panel-bg.png"
import RedoButton from "../assets/icons/btn_panel-redo.png"
import UndoButton from "../assets/icons/btn_panel-undo.png"
import ExitButton from "../assets/icons/btn_panel-exit.png"
import CopyButton from "../assets/icons/btn_copy.png"
import ShareButton from "../assets/icons/btn_share.png"
import EmojiButton from "../assets/icons/btn_feedback.png"

import NavButton from "../components/NavButton"

import rotateTo from "../components-aframe/rotateTo"

import controlBox from "../components-aframe/controlBox"
import fixed from "../components-aframe/fixed"

import frameButton from "../components-aframe/frameButton"

import UrlEncoder from "../helpers/url-encoder"

const uCoder = new UrlEncoder("AIzaSyCb96Oin5QxSdlHOgr9SO5VKUnZge5l5D8")

const SliderMaterial = {
    src: ToggleImage,
	transparent: true
}

class ToggleSlider extends Component {

    // getImage() {
    //     if (this.props.globalState.searchType === "IMAGE_SEARCH") {
    //         SliderMaterial.src = ToggleImage;
    //     } else {
    //         SliderMaterial.src = ToggleText;
    //     }
    // }

    constructor(state) {
        super(state)

        this.btnMaterial = {
            shader: "flat", 
            transparent: true,
        }

        this.state = {
            material: {
                ...this.btnMaterial,
                src: ToggleImage,
            },

            fixed: true,

            velocity: 0.01,
            curY: 0,
        }

        this.lastCam = 0;
    }

    renderImage() {
        return (
            <Entity
                geometry={{primitive: "plane", width: 2, height: 0.73}}
                material={this.state.material}

                position={{x: 1.0, y: 0, z: 0.1}}

                events={{
                    clickUp: () => {
                        console.log("Text Search Clicked");

                        if (this.props.globalState.searchType === "IMAGE_SEARCH") {

                            this.setState({
                                material: {
                                    transparent: true,
                                    src: ToggleText
                                }
                            });
                            this.props.setSearchState("TEXT_SEARCH")

                        } else {

                            this.setState({
                                material: {
                                    transparent: true,
                                    src: ToggleImage
                                }
                            });
                            this.props.setSearchState("IMAGE_SEARCH")
                        }

                    }
                }}

                frame-button={{
                    button: true,
                }}
            />
        )
    }

    shareItems() {
        this.props.generateLinkHUD()

        uCoder.encodeData(this.props.sceneItems)
        .then( url => {
            console.log(url)
            this.props.setLinkHUD(url)

        })
    }

    addIcon() {
        console.log("Create stuff")
        this.props.setWorldState("WORLD_ICON")
    }

    render() {

        return (

            <Entity control-box>
               <Entity
                    // geometry={{primitive: "plane", height: 1.2, width: 5}}

                    // material={{ ...this.btnMaterial, src: PanelBackground, }}

                    rotation={{x: -45, y: 0, z: 0}}
                    position={{x: 0, y: -2.0, z: -4.71}}
                    scale={{x: 0.7, y: 0.7, z: 1}}
                >

                    <NavButton 

                        src={ExitButton}

                        text={"switch space"}
    
                        position={{x: -1.6, y: 0, z: 0.1}}
                        click={ () => this.props.switchSpaceHUD() }

                    />

                    <NavButton 

                        src={ShareButton}
    
                        text={"share"}

                        position={{x: -0.6, y: 0, z: 0.1}}
                        click={ () => this.shareItems() }

                    />

                    <NavButton 
                        src={EmojiButton}
    
                        text={"add emoji"}

                        position={{x: 2.6, y: 0, z: 0.1}}
                        click={ () => this.addIcon() }

                    />


                    {this.renderImage()}

                </Entity>

                

            </Entity>
        );
    }
}

export default ToggleSlider



// WEBPACK FOOTER //
// ./src/components/toggle-slider.js